import { render, staticRenderFns } from "./PerfectScrollbar.vue?vue&type=template&id=63b76f2a"
import script from "./PerfectScrollbar.vue?vue&type=script&lang=js"
export * from "./PerfectScrollbar.vue?vue&type=script&lang=js"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports